var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SimpleToolVariable_1;
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { ToolParameterType, ToolParameterValueType } from './toolParameter';
import { ToolVariable } from './toolVariable';
const schema = {
    $id: 'urn:wisepipe-base-pipe:SimpleToolVariable',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1 },
        expectedValueType: { type: 'string', enum: Object.values(ToolParameterValueType) },
        parameterType: { type: 'string', enum: Object.values(ToolParameterType) }
    },
    required: ['name', 'parameterType']
};
let SimpleToolVariable = SimpleToolVariable_1 = class SimpleToolVariable extends ToolVariable {
    constructor(name, type, expectedValueType, parameterType) {
        super(type);
        this.name = name;
        this.parameterType = parameterType;
        this.expectedValueType = expectedValueType;
        JSON.validate(this, SimpleToolVariable_1);
    }
    getParam(parameters) {
        return parameters.get(this.parameterType, this.name, true);
    }
    getValue(parameters) {
        const param = this.getParam(parameters);
        if (param.valueType !== this.expectedValueType)
            throw new Error(`Expected value type ${this.expectedValueType} but got ${param.valueType}`);
        return param.value;
    }
};
SimpleToolVariable = SimpleToolVariable_1 = __decorate([
    JsonSchema(schema)
], SimpleToolVariable);
export { SimpleToolVariable };
//# sourceMappingURL=simpleToolVariable.js.map